import { getEmptyParagraphNode } from '@doltech/utils/lib/editor';
import { types as t } from 'mobx-state-tree';

import { SlateNode } from './slate-node.store';

export const SlateEditor = t.model('SlateEditor', {
  children: t.array(SlateNode),
  selection: t.maybeNull<any>(t.string),
  type: t.maybeNull<any>(t.string),
  number: t.maybeNull<any>(t.string),
});

export const defaultSlateValue = [getEmptyParagraphNode()];
export const defaultEditorValue = JSON.stringify(defaultSlateValue);
